export enum ORDER_TYPES {
  DELIVERY = 'delivery',
  FRICTIONLESS = 'frictionless',
  PICKUP = 'pickup',
  SCAN_AND_GO = 'scan_and_go',
  ALL = 'all',
}
